import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { EDDItemDetails } from '../../../edd/index';
import { initiatePayment, createOrder } from '../../actions/payment';
import Header from '../../../cart/components/responsive/CartDesktopHeader';
import OrderSummary from '../../../cart/components/responsive/OrderSummary';
import { getBannerResult } from '../../../myaccount/actions/personalInfo';
import ShippingAddress from '../responsive/ShippingAddress';
import Footer from './Footer';
import Button from '../../../components/common/Button';
import ErrorMessage from '../../../components/common/ErrorMessage';
import properties from '../../../modules/ajio-util/properties';
import { NotFoundPageContent } from '../../../components/desktop/NotFoundPage.js';
import { getServiceOrNonServicabilityItems } from '../../../edd/utils/utils.js';
import Layout from '../../../components/desktop/Layout';

import { beautyCheck } from '../../../utils/StandardSizeUtils';
import {
  getCustomCODMessage,
  getPaymentMsg,
  getLuxeFlags,
  getEGiftCard,
  getShowConsentFormForCards,
  getStoreWiseDeliveryFeeTags
} from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import screen from '../../../refresh/constants/pageType.constant';
import { gtmEventPush, gtmPagePush } from '../../../modules/ga/GTMdatalayer';
import { displayValueWithSymbol } from '../../../utils/price';
import { getProductStoreMappingData } from '../../../refresh/utils/productStoreMappingUtils';
import { readCookie } from '../../../components/common/Cookie';
import {
  getCodConvenienceData,
  getGA4AJIOEnable,
  getEnablePreOrderOnbording3pVendors,
  getOnboarding3PVendorsText,
  getEMIEnable,
  getGiftWithProductConfig,
  getEnableCODCheck,
  getEnableAjioMemberShipProgram,
  getAjioSuperCashConfigForPayment,
  getSegmentTrackingEnabledFlag,
  getAssetConfig,
  getGSTFlag,
  bank_discount_clawback_config,
  getEmiDiscountEnable,
  getEmiDiscountSPCConfig,
  getEmiDiscountEnableForSPC
} from '../../../refresh/selectors/featureFlagsSelector';
import { getVariant } from '../../../refresh/organism/ABFeature/Feature';
import { getDeliveryFeeThresholdAmount, getMembershipBenefitResponse } from '../../../refresh/selectors/cartSelector';
import getShowCodConvenienceFlowFlag from '../../../refresh/utils/codConvenienceUtils';
import { getGiftWithProductEnable } from '../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { formatDate } from '../../../refresh/utils/dateUtils';

const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;
class RetryPaymentPage extends Component {
  constructor(props) {
    super(props);
    this.labels = {
      backToShipping: 'Back to Shipping',
      confirmOrderPay: 'Confirm Order & Pay',
      backToOrder: 'Back to Orders'
    };
    this.state = {
      customerCare: {
        formatted: 18008899991,
        unformatted: '1800-889-9991'
      },
      gateWayInfo: {},
      retrypayment: false
    };
  }

  componentDidMount() {
    const { cart = {}, storeName } = this.props;
    ga('send', {
      hitType: 'pageview',
      eventCategory: 'Open Screen',
      eventAction: 'Retry payment page',
      eventLabel: 'Retry Payment Page Landing',
      hitCallback() {
        console.log('Event received');
      }
    });
    const { paymentRetry: { pageName = '', pageType = '' } = {} } = screen;
    const payable = _get(cart, 'orderSummary.bagTotal.value', '');
    gtmPagePush(pageName, pageType, window?.__ENV__, {
      payment_amount: payable,
      store: storeName
    });
  }

  renderCartCard = (cartItems, enableGiftWithProduct = false) => {
    return cartItems.map((cartItem, index) => {
      const price = _get(cartItem, 'totalPrice.value', '');
      const imageURL = _get(cartItem, 'images.0.url', '');
      const {
        isGiftProduct = false
      } = cartItem
      const { valueWithUnit: volume, hideSizes } = beautyCheck(cartItem.variantOptionQualifiers);
      return (
        <div className="cart-card-box" key={index}>
          <div className="box-media">
            <img src={replaceWithJioCDN(imageURL)} style={{padding: '3px'}} />
           { enableGiftWithProduct && isGiftProduct && <img className="gift-tag" src={`${imageBaseRef}FreeTag.svg`} alt="Free Tag" />
           }
          </div>
          <div className="box-detail1">
            <div className="box-detail-heading">{cartItem.name}</div>
            <div className="box-detail-value">{displayValueWithSymbol(price.toFixed(2))}</div>
          </div>
          <div className="box-detail2">
            {cartItem.color ? <div className="box-detail-heading">Color</div> : null}
            <div className="box-detail-value">{cartItem.color}</div>
          </div>
          {!(volume || hideSizes) ? (
            <div className="box-detail3">
              <div className="box-detail-heading">Size</div>
              <div className="box-detail-value">{cartItem.size}</div>
            </div>
          ) : null}
          <div className="box-detail3">
            <div className="box-detail-heading">Qty</div>
            <div className="box-detail-value">{cartItem.quantity}</div>
          </div>
        </div>
      );
    });
  };

  handlePaymentClick = (event, newDesignLuxe, showConvenienceFeeFlow) => {
    // console.log('Desktop Retry Button Click')
    const { metaData: { sis = false, name: sisName = '' } = {} } = this.props;

    const { cartItem = [], enableGST = false, gstDetails = {} } = this.props;
    const gstInfo = {
      enableGST,
      gstDetails,
      cartItemGST: (cartItem || []).map(x => ({
        code: x.code,
        isGstEligible: x.isGstEligible
      }))
    };
    sessionStorage.setItem('gstInfo', JSON.stringify(gstInfo));

    const channelType =  'WEB';
    ga('send', {
      hitType: 'event',
      eventCategory: 'Buttontap',
      eventAction: 'Retry_payment_btn-Clicked',
      eventLabel: 'Retry Payment clicked'
    });
    gtmEventPush({
      event: 'proceed_to_pay_retry',
      event_category: 'checkout interactions',
      event_action: 'proceed to pay - retry',
      store_type: newDesignLuxe ? 'Luxe' : 'Ajio'
    });
    event.preventDefault();
    this.props.getBannerResult(
      channelType,
      showConvenienceFeeFlow
    ).then((response) => {
        if (_get(response, 'errors')) {
          window.location = '/cart';
        } else {
          this.paymentRef.action = `${properties.getProperty('paymentURL')}/pay`;
          this.paymentRef.submit();
        }
    })
  };

  render() {
    const {
      edd = {},
      bannerInfo: { bannerInfo = {}, customerInfo = {} } = {},
      httpError = {},
      httpError: { error = {}, errorS = false } = {},
      basicInfo = {},
      cart = {},
      cartItem = {},
      location: { pathname = '' } = {},
      isServerRendering = false,
      customCODMessage,
      metaData: {
        sis = false,
        name: sisName = '',
        subHeaderHeight = 0,
        primaryHeaderHeight = 100
      } = {},
      paymentMsg,
      eGiftCard,
      codConvenienceData,
      deliveryFeeThresholdAmount,
      ShowConsentFormForCards,
      storeWiseDeliveryFeeTags = {},
      ga4AjioEnable,
      onboarding3PVendorsText,
      enablePreOrderOnbording3pVendors = false,
      emiEnable,
      enableGiftWithProduct,
      giftWithProductConfig = {},
      giftItem,
      enableCODCheck = false,
      membershipBenefitResponse,
      enableSubscription,
      memberShipStaticValues = {},
      ajioSuperCashPaymentConfig = {},
      segmentTrackingEnabledFlag,
      jioCdnUrl = '',
      assetConfig = {},
      enableGST = false,
      gstDetails = {},
      bankDiscountClawbackConfig = {},
      membershipData = {},
      bankDiscountConfig,
      noCostEMIMasterFlag = false,
      noCostEMIConfig = {}
    } = this.props;
    const { isEnabled = false } = bankDiscountConfig;
    const  { odpSummary = '' } = giftWithProductConfig;
    const { showCodConvenienceFeeFlow = 'OFF' } = codConvenienceData;
    const showConvenienceFeeFlow = getShowCodConvenienceFlowFlag(showCodConvenienceFeeFlow);

    const { newDesignLuxe } = this.props;

    const { eddDetails, activePincode, codEligible: eddCodEligible, isCartItemsEDDFetching } = edd;
    let orderId = '';
    let deliverableItems = [];
    if (activePincode) {
      deliverableItems =
        getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, true) || [];
    }

    if (this.state.retrypayment) {
      const orderCodeAry = pathname.split('/');
      orderId = orderCodeAry[orderCodeAry.length - 1];
    }

    let containsLuxe = false;
    const userId = decodeURIComponent(readCookie('CI')) || '';
    cartItem?.forEach(item => {
      const storeValue = getProductStoreMappingData(
        userId,
        item.code.substr(0, item.code.length - 3)
      );
      if (storeValue === 'luxe') containsLuxe = true;
    });

    const {
      userDetail: {
        savingBreakup = {},
        orderLeft = 0,
        boughtOn = '',
        validTill = '',
        totalSavings = 0
      } = {}
    } = membershipData;
    const { deliveryFeeSaving = 0, membershipSaving = 0, platformFeeSaving = 0 } = savingBreakup;
    const membershipInfo = {
      subscription_status: membershipData?.status || 'NA',
      subscription_version: membershipData?.detail?.identifier || 'NA',
      subscription_id: membershipData?.detail?.productId || 'NA',
      subscripiton_number: 'NA',
      subscription_start_date: boughtOn ? formatDate(boughtOn) : 'NA',
      subscription_end_date: validTill ? formatDate(validTill) : 'NA',
      subscribed_orders_left: orderLeft,
      subscription_first_purcase_date: 'NA',
      total_account_savings: totalSavings,
      platform_account_savings: platformFeeSaving,
      delivery_account_savings: deliveryFeeSaving,
      membership_discount_account_savings: membershipSaving
    };
    const newBannerInfo = {
      ...bannerInfo,
      orderSummary: {
        ..._get(bannerInfo, 'orderSummary', {}),
        bagTotal: _get(cart, 'orderSummary.bagTotal.value', ''),
        bagDiscount: _get(cart, 'orderSummary.bagDiscount.value', ''),
        gst: _get(cart, 'orderSummary.exclusiveGSTCharge.value'),
        membershipDetails: _get(cart, 'orderSummary.membershipDetails')
        // giftWrapCharge: _get(cart, 'orderSummary.giftWrapCharge.value')
      },
      notes:
        customCODMessage.length > 0
          ? {
              status: true,
              message: customCODMessage,
              paymentMsg,
              SEND_WALLETS_IN_DISPLAY_PRIORITY: true,
              newDesignLuxe: newDesignLuxe ? 'luxe' : 'ajio',
              showGiftCard: eGiftCard,
              contains_luxe: containsLuxe,
              showConvenienceFeeFlow,
              codConvenienceData: JSON.stringify(codConvenienceData),
              deliveryFeeThresholdAmount,
              deviceFingerprint: readCookie('_fpuuid') || '',
              ShowConsentFormForCards,
              ga4AjioEnable,
              emiEnable,
              segmentTrackingEnabledFlag,
              jioCdnUrl,
              jioCdnAssetConfig: JSON.stringify(assetConfig),
              isClawBackEnabled: isEnabled,
              noCostEMIMasterFlag
            }
          : {
              newDesignLuxe: newDesignLuxe ? 'luxe' : 'ajio',
              showGiftCard: eGiftCard,
              contains_luxe: containsLuxe,
              ShowConsentFormForCards,
              ga4AjioEnable,
              emiEnable,
              segmentTrackingEnabledFlag,
              deviceFingerprint: readCookie('_fpuuid') || '',
              jioCdnUrl,
              jioCdnAssetConfig: JSON.stringify(assetConfig),
              isClawBackEnabled: isEnabled,
              noCostEMIMasterFlag
            },
      multipleWalletsSupported: true,
      storeWiseDeliveryFeeTags,
      onboarding3PVendorsText,
      membershipBenefitResponse,
      memberShipStaticValues: memberShipStaticValues || {},
      enableSubscription,
      enablePreOrderOnbording3pVendors,
      isGiftProductsInCart: enableGiftWithProduct && cartItem?.length > 0 && (cartItem || []).filter(item => !!item?.isGiftProduct)?.length > 0 && odpSummary,
      cartItemGWP:
        enableGiftWithProduct &&
        cartItem?.length > 0 &&
        (cartItem || []).map(x => ({
          code: x.code,
          isGiftProduct: x.isGiftProduct,
          giftQuantity: x.giftQuantity
        })),
      enableCODCheck,
      ajioSuperCashPaymentConfig: ajioSuperCashPaymentConfig || {},
      bankDiscountClawbackConfig,
      gstInfo: {
        enableGST,
        gstDetails,
        cartItemGST: (cartItem || []).map(x => ({
          code: x.code,
          isGstEligible: x.isGstEligible,
        }))
      },
      membershipInfo,
      noCostEMIConfig
    };

    return (
      <Layout
        header={false}
        footerSeo={false}
        isFooter={false}
        isServerRendering={isServerRendering}
        basicInfo={basicInfo}
      >
        <div
          className={`${newDesignLuxe ? 'luxe-newdesign' : ''} checkout-container`}
          id="dCheckoutContainer"
        >
          <div className="back-to-shipping">
            <a href="/shipping">Back to Shipping</a>
          </div>
          <Header isRetryPayment key="checkout-flow-header" basicInfo={basicInfo} />
          {(Object.keys(httpError).length != 0 && error.errorType == 'basic') || errorS ? (
            <div className="view">
              <NotFoundPageContent />
            </div>
          ) : (
            <div className="retry-payment-container">
              {Object.keys(httpError).length != 0 && error.errorType == 'info' ? (
                <div className="err-msg-blk">
                  <ErrorMessage message={error.message} device="mobile" showCloseButton={false} />
                </div>
              ) : (
                ''
              )}
              <div className="checkout-section">
                <div className="checkout-section-info">
                  <div>
                    <div className="info-text1">
                      {/* <div className="checkout-error"> */}
                      <span className="checkout-error">:(</span>
                      {/* </div> */}
                      {/* <div className="checkout-error"><span className="ic-close-quickview"></span></div> */}
                      <span>Oops! Your payment has failed</span>
                    </div>
                    <div className="info-text2">
                      In case the amount is debited from your account, the refund will be initiated
                      within 48 hours and credited to your account within 5-7 business days.
                    </div>
                  </div>

                  <div className="shipping-page-btn-wrapper">
                    <Button
                      className={`button shipping-button ${
                        deliverableItems.length !== cartItem.length || isCartItemsEDDFetching
                          ? 'btn-disabled'
                          : ''
                      }`}
                      form="payment-submit"
                      onClick={e =>
                        this.handlePaymentClick(e, newDesignLuxe, showConvenienceFeeFlow)
                      }
                    >
                      RETRY PAYMENT
                    </Button>
                    {/* <div className="padding-top-10"><EDDItemDetails/></div> */}
                    <form id="payment-submit" method="post" ref={ref => (this.paymentRef = ref)}>
                      {_map(newBannerInfo, (elm, key) => {
                        const value = JSON.stringify(elm);
                        const name = JSON.stringify(key);
                        return <input type="hidden" key={key} name={name} value={value} />;
                      })}
                    </form>
                  </div>
                </div>
                <div className="checkout-section-detail">
                  <div className="detail-heading">Your Current Order</div>
                  <div className="cart-container">{this.renderCartCard(cartItem, enableGiftWithProduct)}</div>
                </div>
              </div>
              <div className="right-panel">
                <OrderSummary cart={cart} retryPaymentPage giftItem={giftItem} />
                <ShippingAddress cart={cart} />
              </div>
            </div>
          )}
        
          <Footer customerCare={this.state.customerCare} />
        </div>
      </Layout>
    );
  }

  _buttonSection() {
    return (
      <div className="button-wrapper" key="action-button">
        {this.state.retrypayment ? (
          <a href="/my-account/orders">
            <button className="button back-to-shipping" key="back-to-shipping">
              {this.labels.backToOrder}
            </button>
          </a>
        ) : (
          <button
            className="button back-to-shipping"
            key="back-to-shipping"
            onClick={() => {
              history.back();
            }}
          >
            {this.labels.backToShipping}
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    order = {},
    httpError = {},
    metaData = {},
    bannerInfo = {},
    cart = {},
    edd,
    flags,
    cartItem = []
  } = state;
  const giftItemArray = cartItem?.filter(item => item?.isGiftProduct);

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const ShowConsentFormForCards = getShowConsentFormForCards(flags);
  const membershipBenefitResponse = getMembershipBenefitResponse(state);
  const enableSubscription = getEnableAjioMemberShipProgram(flags, state) || false;
  const assetConfig = getAssetConfig(state?.flags);
  const jioCdnUrl = assetConfig?.isJioCDNEnabled === 'ON' && assetConfig?.jioCDNAssetUrl || ''
  return {
    order,
    jioCdnUrl,
    assetConfig,
    httpError,
    metaData,
    bannerInfo,
    cart,
    edd,
    cartItem,
    customCODMessage: getCustomCODMessage(flags),
    paymentMsg: getPaymentMsg(flags),
    eGiftCard: getEGiftCard(flags),
    ShowConsentFormForCards: getShowConsentFormForCards(flags),
    storeWiseDeliveryFeeTags: getStoreWiseDeliveryFeeTags(flags),
    newDesignLuxe,
    storeName,
    codConvenienceData: getCodConvenienceData(state),
    deliveryFeeThresholdAmount: getDeliveryFeeThresholdAmount(state),
    ga4AjioEnable: getGA4AJIOEnable(flags),
    onboarding3PVendorsText: getOnboarding3PVendorsText(state),
    enablePreOrderOnbording3pVendors: getEnablePreOrderOnbording3pVendors(flags),
    emiEnable: getEMIEnable(flags),
    enableGiftWithProduct: getGiftWithProductEnable(flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    giftItem: giftItemArray,
    enableCODCheck: getEnableCODCheck(flags),
    membershipBenefitResponse,
    memberShipStaticValues: state?.cacheData?.staticContent,
    enableSubscription,
    ajioSuperCashPaymentConfig: getAjioSuperCashConfigForPayment(flags, storeName),
    segmentTrackingEnabledFlag: getSegmentTrackingEnabledFlag(flags),
    enableGST: getGSTFlag(state),
    gstDetails: state?.cart?.gstDetails || {},
    bankDiscountClawbackConfig: bank_discount_clawback_config(state),
    membershipData: state?.membership?.membershipData || {},
    bankDiscountConfig: bank_discount_clawback_config(state),
    noCostEMIMasterFlag: getEmiDiscountEnableForSPC(state),
    noCostEMIConfig: getEmiDiscountSPCConfig(state)
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    initiatePayment: (paymentOption, cb) => {
      dispatch(initiatePayment(paymentOption, cb));
    },
    createOrder: (option, cb) => {
      dispatch(createOrder(option, cb));
    },
    getBannerResult: (deviceType, showConvenienceFeeFlow) => {
      return dispatch(getBannerResult(deviceType, showConvenienceFeeFlow));
    }    
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RetryPaymentPage));
